import React, { useEffect } from "react";
import { Box, Grid, Typography, Card, CardMedia, CardContent, Link } from "@mui/material";
import { useNavigate } from "react-router-dom";
import CountUp from "react-countup";
import AOS from "aos";
import "aos/dist/aos.css";

// Image Imports
import youthmentoring from "../Assets/contributionImage/youth-mentoring.png";
import doctors from "../Assets/contributionImage/doctors.jpg";
import treePlantation from "../Assets/contributionImage/Treeplantation.jpg";
import animals from "../Assets/contributionImage/animals.jpg";
import donateFood from "../Assets/contributionImage/donateFood.jpg";
import fourthImage from "../Assets/homeImages/fourthImage.jpg";

const Work = () => {
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({ duration: 2500 });
  }, []);

  const workInfoData = [
    { image: youthmentoring, title: "Education", route: "/education" },
    { image: doctors, title: "Medical Sector", route: "/health" },
    { image: treePlantation, title: "Tree Plantation", route: "/treeplantation" },
    { image: animals, title: "Water For Wildlife", route: "/waterwildlife" },
    { image: donateFood, title: "Donate Food", route: "/foodDonation" },
    { image: donateFood, title: "Extra Activities", route: "/extraActivity" },
  ];

  const handleImageClick = (route) => navigate(route);

  return (
    <Box sx={{ py: 5, px: 2, backgroundColor: "#f5f5f5" }}>
      {/* Impact Section */}
      <Box textAlign="center" mb={4}>
        <Typography variant="h4" fontWeight="bold" gutterBottom>
          <span style={{ marginRight: "10px" }}>OUR</span>
          <span style={{ textDecoration: "underline", color: "#ff6f00" }}>Impact</span>
        </Typography>
      </Box>

      {/* Stats Section */}
      <Grid container spacing={3} justifyContent="center">
        {[
          { count: 678, text: "Education-Milestones" },
          { count: 15000, text: "Medical Aid Provided" },
          { count: 1300, text: "Trees-Planted" },
        ].map((item, index) => (
          <Grid item xs={12} sm={4} key={index}>
            <Box
              sx={{
                backgroundColor: "white",
                p: 3,
                borderRadius: 2,
                boxShadow: 3,
                textAlign: "center",
                "&:hover": { boxShadow: 6 },
              }}
              data-aos="fade-up"
            >
              <Typography variant="h3" color="orange">
                <CountUp end={item.count} duration={5} />+
              </Typography>
              <Typography variant="h6" fontWeight="bold">{item.text}</Typography>
            </Box>
          </Grid>
        ))}
      </Grid>

      {/* The Way We Work */}
      <Box textAlign="center" my={5}>
        <Typography variant="h4" fontWeight="bold">
          THE Way We Work
        </Typography>
      </Box>
      <Box textAlign="center" mb={5} data-aos="zoom-in">
        <CardMedia component="img" image={fourthImage} alt="Our Work" sx={{ borderRadius: 2, boxShadow: 3, maxHeight: 400 }} />
      </Box>

      {/* Contributions Section */}
      <Box textAlign="center" mb={4}>
        <Typography variant="h4" fontWeight="bold">
          Our Contributions
        </Typography>
      </Box>

      <Grid container spacing={3} justifyContent="center">
        {workInfoData.map((data, index) => (
          <Grid item xs={12} sm={6} md={4} key={data.title}>
            <Card
              sx={{
                cursor: "pointer",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
                "&:hover": { transform: "scale(1.05)", boxShadow: 6 },
              }}
              onClick={() => handleImageClick(data.route)}
              data-aos="fade-up"
            >
              <CardMedia component="img" height="200" image={data.image} alt={data.title} />
              <CardContent>
                <Typography variant="h6" fontWeight="bold" align="center">
                  {data.title}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Work;
